/*!
 *  Fluid Width Video
 */
var $ = require('jquery');

$.fn.fluidWidthVideo = function(settings) {
	settings = jQuery.extend({
		hsState: false,
		state: "recalc",
		wrapper: ".videoBox"
	}, settings);
	/**/
	var targetVideosOnPage = $("iframe", $(settings.wrapper)),
			wrappElement = $(settings.wrapper);
	if(settings.state=="init"){
		targetVideosOnPage.each(function() {
			var t = $(this);
			t.attr('data-aspectRatio', this.height / this.width)
					.removeAttr('height')
					.removeAttr('width');
		});
	}
	var newWidth = wrappElement.width();
	targetVideosOnPage.each(function() {
		var t = $(this);
		t.width(newWidth)
				.height(newWidth * t.attr('data-aspectRatio'));
	});
  if(settings.hsState===true){
    if (top.hs != undefined) {
      var expander = top.hs.getExpander();
      if (expander) {
        expander.reflow();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/fluidWidthVideo.js